import api from './axios';

// 이메일계정찾기
export const emailSearch = async (params) => {
  const response = await api.get('/knouUser/login/getEmailSearch',{params: params});
  return response.data;
};

// 아이디찾기
export const idSearch = async (params) => {
  const response = await api.get('/knouUser/login/getIdSearch',{params: params});
  return response.data;
};

// 비밀번호찾기
export const passwordSearch = async (params) => {
  const response = await api.get('/knouUser/login/getPasswordSearch',{params: params});
  return response.data;
};

// 비밀번호재설정
export const updatePassword = async (reqData) => {
  const response = await api.post('/knouUser/login/updatePassword', reqData);
  return response.data;
};

// 핸드폰 본인인증 체크
export const phoneCertificationCheck = async (reqData) => {
  const response = await api.post('/knouUser/login/phoneCertificationCheck', reqData);
  return response.data;
};

// 이메일 본인인증 체크
export const emailCertificationCheck = async (reqData) => {
  const response = await api.post('/knouUser/login/emailCertificationCheck', reqData);
  return response.data;
};

// 휴면계정회원 체크
export const getInactivityMemberCheck = async (params) => {
  const response = await api.get("/knouUser/login/getInactivityMemberCheck", { params: params });
  return response.data;
}
